webpackJsonp([75618627151103],{

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostTestTerms = function (_React$Component) {
	  _inherits(PostTestTerms, _React$Component);
	
	  function PostTestTerms(props) {
	    _classCallCheck(this, PostTestTerms);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  PostTestTerms.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'BlogPostPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        _marketing.BlogPost,
	        { title: 'So many testing terms, so little time?' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'People get really mixed up with web development testing terms. Let\u2019s try to straighten this out:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Unit'
	              )
	            ),
	            '\u200A\u2014\u200ATest each individual piece of code.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Integration'
	              )
	            ),
	            '\u200A\u2014\u200ATest many pieces of code together.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Functional'
	              )
	            ),
	            '\u200A\u2014\u200AIntegration tests that focus on business requirements.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Regression'
	              )
	            ),
	            '\u200A\u2014\u200ATest if a change didn\u2019t break anything that worked previously.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Smoke/Sanity'
	              )
	            ),
	            '\u200A\u2014\u200ATest that it doesn\u2019t just blow up immediately.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _react2.default.createElement(
	                'em',
	                null,
	                'Acceptance'
	              )
	            ),
	            '\u200A\u2014\u200ATest done by an actual end user.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'All of the testing above can be done manually, but only some can be done with automated tools.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Build tests'
	            )
	          ),
	          ' are any of the above testing types that have been automated and integrated into your build system.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h1',
	          { id: 'a-not-so-crazy-story-' },
	          'A not-so-crazy story:'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Bob Sagat, a full-stack developer, is in charge of a new project. His manager is telling him to test the crap out of it. It\u2019s a node/react dashboard. Here is his next 6 months of development:'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { id: 'phase-1-initial-development-phase' },
	          'Phase 1: Initial development phase'
	        ),
	        _react2.default.createElement(
	          'h4',
	          { id: 'node-api-' },
	          'Node API:'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Uses mocha to write ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Unit'
	            )
	          ),
	          ' tests for controllers, models, services, etc.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Uses mocha to write ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Integration'
	            )
	          ),
	          ' tests which calls the endpoints and asserts the response.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          { id: 'react-' },
	          'React :'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Uses jest to write ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Unit'
	            )
	          ),
	          ' tests for react components.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Uses selenium to have ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Integration/functional'
	            )
	          ),
	          ' tests which opens up a browser and pretends to be a user.'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { id: 'phase-2-almost-about-to-release-' },
	          'Phase 2: Almost about to release!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The QA team starts hammering the project and finds many bugs. As Bob fixes them, his current tests become ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Regression'
	            )
	          ),
	          ' tests, making sure nothing else is busted.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The project manager gives a release candidate to some end users (and the CEO) to play with. These are User ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Acceptance'
	            )
	          ),
	          ' Tests (UAT).'
	        ),
	        _react2.default.createElement(
	          'h3',
	          { id: 'phase-3-release-' },
	          'Phase 3: Release!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The product is out in the wild. Bob writes a few Selenium tests to ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(
	              'em',
	              null,
	              'Smoke/Sanity'
	            )
	          ),
	          ' check the site, which runs every day at midnight.'
	        ),
	        _react2.default.createElement(
	          'h1',
	          { id: 'that-s-it-hope-that-helped-' },
	          'That\u2019s it! hope that helped.'
	        )
	      )
	    );
	  };
	
	  return PostTestTerms;
	}(_react2.default.Component);
	
	exports.default = PostTestTerms;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-post-so-many-testing-terms-so-little-time-js-1be8cd99c12c3bd49bb4.js